import Swal from 'sweetalert2';

export async function notifyConfirmation(message) {

    const result = await Swal.fire({

        title: 'Confirmar',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
            confirmButton: 'custom-notify-confirm-button',
            cancelButton: 'custom-notify-cancel-button'
        }

    });

    return result.isConfirmed;
}

export async function confirmCancelAction() {

    return notifyConfirmation(
        '¿Está seguro que desea cancelar? Puede perder la información diligenciada.',

    );

}

export function showAlert({ message, icon, title }) {

    const autoClose = icon === 'success' || icon === 'info';

    return Swal.fire({

        title: title,
        text: message,
        icon: icon,
        confirmButtonText: 'Aceptar',
        customClass: {
            confirmButton: 'custom-confirm-button'
        },

        timer: autoClose ? 3000 : undefined,
        timerProgressBar: autoClose
    });

}

export function showSessionWarning(durationMs = 60000) {

    let remaining = Math.ceil(durationMs / 1000);
    let interval = null;

    return Swal.fire({

        title: 'Tu sesión está por expirar',
        html: `Por inactividad cerraremos tu sesión en <b>${remaining}</b> segundos.`,
        icon: 'warning',
        timer: durationMs,
        timerProgressBar: true,
        showCancelButton: true,
        confirmButtonText: 'Seguir conectado',
        cancelButtonText: 'Cerrar sesión',
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
            confirmButton: 'custom-notify-confirm-button',
            cancelButton: 'custom-notify-cancel-button'
        },
        didOpen: () => {

            const counter = Swal.getHtmlContainer()?.querySelector('b');

            interval = setInterval(() => {
                remaining -= 1;
                if (counter) counter.textContent = String(Math.max(remaining, 0));
            }, 1000);
        },
        willClose: () => {
            if (interval) clearInterval(interval);
        }
    });

}

export function showLoader(message) {

    return Swal.fire({
        html: `
                <div style="display: flex; flex-direction: column; align-items: center;">
                    <img src="/loaders/loading.gif" alt="Loading" style="width: 90px; height: 90px; margin-bottom: 10px;">
                    <span>${message}</span>
                </div>
            `,
        showConfirmButton: false,
    });

}

export function closeLoader() {

    Swal.close();

}

export function showHtmlNotification(htmlContent, parameters = {}) {

    Swal.fire({
        html: htmlContent,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        ...parameters,
    });
}

export function showAlertMessage(success, messageSuccess = null, messageError, succesTitle, warningTitle) {

    if (success) {

        return showAlert({

            message: messageSuccess,
            icon: 'success',
            title: succesTitle,

        });

    }

    return showAlert({

        message: messageError,
        icon: 'error',
        title: warningTitle,

    });

}

export function showLoaderParameters(message) {

    return Swal.fire({
        html: `
                <div style="display: flex; flex-direction: column; align-items: center; padding: 10px; max-width: 300px;">
                    <img src="/loaders/loading.gif" alt="Loading" style="width: 40px; height: 40px; margin-bottom: 5px;">
                    <span style="font-size: 14px; text-align: center;">${message}</span>
                </div>
            `,
        showConfirmButton: false,
        width: "350px",
        padding: "15px",
    });

}

export function showValidationListAlert({ title, icon, message, data }) {

    return Swal.fire({
        title: title,
        icon: icon,
        html: `
                <p><strong>${message}</strong></p>
                <div class="alert alert-danger text-left mt-6" role="alert">
                    <ul class="mb-0">
                        ${data}
                    </ul>
                </div>
            `,
        showCloseButton: true,
        focusConfirm: true,
        confirmButtonText: 'Ok',
        customClass: {
            confirmButton: 'custom-confirm-button'
        },
    });
}

